export default __webpack_public_path__ + "static/media/document-placeholder.8ad3d9ea.svg";